var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "clearfix",
      attrs: { "data-cy": "token-select-popover" }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.debouncedSearchText,
            expression: "debouncedSearchText"
          }
        ],
        ref: "searchInput",
        staticClass: "form-control p-r-30",
        attrs: { type: "search", placeholder: "Search Token" },
        domProps: { value: _vm.debouncedSearchText },
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.$emit("blur")
          },
          input: function($event) {
            if ($event.target.composing) return
            _vm.debouncedSearchText = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-by-dropdown" },
        [
          _vm._l(_vm.showMacros, function(tagCategory, categoryId) {
            return _c(
              "div",
              { key: categoryId, attrs: { "data-cy": "token-category-title" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "group-by-category",
                    attrs: { "data-cy": "token-category-title" },
                    on: {
                      click: function($event) {
                        return _vm.toggleMacrosForCategory(categoryId)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-capitalize group-by-category__main"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("camelCaseFormat")(tagCategory.name)
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa",
                      class: {
                        "fa-angle-down": !_vm.showMacrosDropdown[categoryId],
                        "fa-angle-up": _vm.showMacrosDropdown[categoryId]
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.showMacrosDropdown[categoryId]
                  ? _c(
                      "div",
                      { attrs: { "data-cy": "token-category-macros" } },
                      _vm._l(tagCategory.macros, function(tag) {
                        return _c(
                          "div",
                          {
                            key: tag.id,
                            staticClass: "p-l-15 clickable group-by-tag__name",
                            on: {
                              click: function($event) {
                                return _vm.emitTag(categoryId, tag)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-capitalize",
                                class: {
                                  "group-by-tag__name--not-available": !_vm.tagAvailable(
                                    tag.populatedOn
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("camelCaseFormat")(tag.name)
                                    ) +
                                    " "
                                ),
                                !_vm.tagAvailable(tag.populatedOn)
                                  ? _c("i", {
                                      staticClass: "fa fa-ban m-l-5",
                                      attrs: {
                                        title: _vm.$t("TOKEN_NOT_AVAILABLE_TT"),
                                        "aria-hidden": "true"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.noMacros
            ? _c(
                "div",
                { staticClass: "p-l-5 p-b-5 p-t-5 f-s-13 text-muted" },
                [_vm._v("\n      " + _vm._s(_vm.emptyMacrosMessage) + "\n    ")]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }